import { Box, Typography, Paper, Chip } from "@mui/material";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

export default function CalendarPage() {
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 4 }}>
        <EventOutlinedIcon sx={{ color: "#C9734F", fontSize: 28 }} />
        <Typography variant="h5" sx={{ fontWeight: 700, color: "#0F172A" }}>
          Calendar
        </Typography>
        <Chip
          label="Coming soon"
          size="small"
          icon={<AutoAwesomeRoundedIcon sx={{ fontSize: "14px !important" }} />}
          sx={{
            ml: 1,
            backgroundColor: "#FEF3EC",
            color: "#C9734F",
            fontWeight: 600,
            fontSize: "0.72rem",
            border: "1px solid #f5d5c4",
          }}
        />
      </Box>

      <Paper
        elevation={0}
        sx={{
          p: 6,
          borderRadius: "16px",
          border: "1px solid #E2E8F0",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          minHeight: 340,
        }}
      >
        <EventOutlinedIcon sx={{ fontSize: 56, color: "#CBD5E1" }} />
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#64748B" }}>
          Calendar view coming soon
        </Typography>
        <Typography sx={{ fontSize: "0.875rem", color: "#94A3B8", textAlign: "center", maxWidth: 420 }}>
          A unified calendar showing all upcoming bookings, availability windows, and scheduling activity will be available here.
        </Typography>
      </Paper>
    </Box>
  );
}
